module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/flags/usa-97ea98598c8abce8b039f9b72771ff09.svg";